module.exports = __webpack_public_path__ + "assets/img/0e24e498a299c231252323528166974c.png";